var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white"},[_c('CoverPage'),_c('div',{},[_c('div',{staticClass:"container md:px-12 px-6"},[_c('AboutUs')],1)]),_c('div',{staticClass:"bge3ceff-opa rounded-t-5555 md:mt-12 lg:mt-12"},[_c('DownloadApp'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }